import { render, staticRenderFns } from "./cabinet-fl44-proposals-list.vue?vue&type=template&id=8885538c&"
import script from "./cabinet-fl44-proposals-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-proposals-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8885538c')) {
      api.createRecord('8885538c', component.options)
    } else {
      api.reload('8885538c', component.options)
    }
    module.hot.accept("./cabinet-fl44-proposals-list.vue?vue&type=template&id=8885538c&", function () {
      api.rerender('8885538c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cabinet-fl44-proposals-list.vue"
export default component.exports